import { useFela } from 'react-fela';

import { useVaultsTable } from '../../hooks';
import { VaultsTable } from '../VaultsTable';
import { VaultsTableFilters } from '../VaultsTableFilters';
import * as felaRules from './ManageVaults.rules';

export const ManageVaults = () => {
    const { css } = useFela();
    const { rows, total, isLoading, isError } = useVaultsTable();

    return (
        <div className={css(felaRules.container)}>
            <VaultsTableFilters />
            <VaultsTable rows={rows} total={total} isLoading={isLoading} isError={isError} />
        </div>
    );
};
